import { render, staticRenderFns } from "./tutorial-modal.vue?vue&type=template&id=53303a74&"
import script from "./tutorial-modal.vue?vue&type=script&lang=js&"
export * from "./tutorial-modal.vue?vue&type=script&lang=js&"
import style0 from "./tutorial-modal.vue?vue&type=style&index=0&id=53303a74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports